module.exports = __webpack_public_path__ + "media/components/stylesheets/BrandonText-Bold-2b1e389af0066e0d6c709052f1e2a01d.woff2";